import { Card } from "./ui/card";
import { MessageSquare, ExternalLink } from "lucide-react";
import { useClubInfo } from "../hooks/useClubInfo";

const SURVEY_BASE_URL = "https://app.poolcrm.ru/public-forms-redirect/04xmn9t5qco";

const SurveyBlock = () => {
  const { branchCode, clientPhone, isLoading } = useClubInfo();

  if (isLoading || !branchCode) {
    return null;
  }

  const surveyUrl = `${SURVEY_BASE_URL}?branch_name=${encodeURIComponent(branchCode)}&pn=${clientPhone}&collection_name=nps_scores`;

  return (
    <Card className="mt-6 transition-colors hover:border-primary">
      <div className="p-6">
        <div className="flex items-start gap-4">
          <div className="rounded-lg bg-primary/10 p-3 text-primary">
            <MessageSquare className="h-6 w-6" />
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-medium text-gray-900">Поделитесь мнением</h2>
            <p className="mt-2 text-gray-600">
              Есть пара минут? Ваша обратная связь поможет нам стать лучше.
            </p>
            <a
              href={surveyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-primary hover:underline"
            >
              Пройти опрос
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SurveyBlock;
